// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import 'onsenui/css/onsenui.css';
import 'onsenui/css/onsen-css-components.css';
import store from './store';

import VueOnsen from 'vue-onsenui';

Vue.use(VueOnsen);

Vue.config.productionTip = false

/**
 * 金額をカンマ区切りに表示します。
 * @param val 金額
 */
Vue.filter('addComma', function(val){
  return Number(val).toLocaleString();
});


/* eslint-disable no-new */
new Vue({
  el: '#app',
  store,
  components: { App },
  render: function(createElement) {
    const shop_code = this.$el.getAttribute('shopCode')
    const shop_ip = this.$el.getAttribute('shopIp')
    const api_version = this.$el.getAttribute('apiVersion')
    const port_no = this.$el.getAttribute('portNo')
    const slip_no = this.$el.getAttribute('slipNo')
    const slip_date = this.$el.getAttribute('slipDate')
    return createElement('App',
      {
        props: {
          shop_code: shop_code,
          shop_ip: shop_ip,
          api_version: api_version,
          port_no: port_no,
          slip_no: slip_no,
          slip_date: slip_date,
        }
      })
  },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js